<div class="row info">   


	<div style="margin-bottom:10px" class=" col-12"><b>{{stream.title}}</b></div>

	

    <div class="col-12">

	   <div class="contentWrapper">
  

        <div class="infoWrapper">
        
		<div style="margin-top:0" [innerHTML]="getDescription() || 'Опис'" class="streamPageInfo descriptionInfo"></div>


		
		<div style="display:flex;     flex-wrap: wrap-reverse;">
		
		 
		<div class="editLink">

			<a (click)="openModal(idetInfo)" href="javascript:;">Редагувати</a>
		</div>

		</div>
       </div>
  
       
 
   <div class="coverImageWrapp">

 

        <div   class="coverImage" [style.background]=" stream.coverImage ? 'url(' + stream.thumbImage +')' : ''" ></div>

	<div class="coverImageControls">
       		 <p *ngIf="!stream.coverImage"><a (click)="loadCoverInput.click()" href="javascript:;">Завантажити обкладинку</a>
		    <input #loadCoverInput (change)="loadCover($event.target)" style="display:none" class="hidden" type="file">
		</p>
	  
		<div *ngIf="stream.coverImage">
		    <p><a (click)="deleteCover()" href="javascript:;">Видалити обкладинку</a></p>
		</div>
	 </div>
	 
    </div>



  </div>



  </div>



 </div>

  
 <ng-template #idetInfo  let-data   let-ref="dialogRef">

<div style="min-width:320px;">
  <form [formGroup]="infoForm"  (ngSubmit)="submitInfoForm(ref)">
	    <nb-card>
    <nb-card-header>

	
	<div style="display:flex; width:100%">
    <span>Редагувати опис</span>   
     <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
	</div>
</nb-card-header>
    <nb-card-body>
	<div>
      
        <div class="form-group">
                     <label for="stream-title">Заголовок</label>

          <div class="input-group">
            <input id="stream-title" 
            formControlName="title"
            nbInput fullWidth name="title" value="{{stream.title}}" />
            

          </div>
           
          <span *ngIf="infoForm.get('title').invalid && infoForm.get('title').touched" class="fs--2 text-danger">
            <span *ngIf="infoForm.get('title').errors.required">Заголовок обов'язкове поле</span>
        </span>
        </div>
  
        <div class="form-group">
            <label for="stream-description">Опис</label>
            <div class="input-group">
              <textarea id="stream-description" 
              formControlName="description"
               nbInput fullWidth name="description" >{{stream.description}}</textarea>
            </div>
         </div>

	</div>
</nb-card-body>
    <nb-card-footer>
     
       
	<div style="display:flex; width:100%">
          
          <button style="display:flex; margin-left:auto; cursor: pointer;"  nbButton status="primary" [disabled]="infoForm.invalid" type="submit">Зберегти</button>

        </div>
    </nb-card-footer>
  </nb-card>
  
    </form> 
</div>
  </ng-template>
  
   

  <ng-template #dateModal  let-data   let-ref="dialogRef">

    <div style="max-width:500px">
           <nb-card>
        <nb-card-header>
    
      
      <div style="display:flex; width:100%">
        <span>Дата початку трансляції</span>   
         <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
      </div>
    </nb-card-header>
        <nb-card-body>
      <div>
          <div>
            <div>  <label>Дата:</label> </div>
            
            <input nbInput class="DateInput"   #dateInput [(ngModel)]="dateAndTime.date" placeholder="__.__.____"  [nbDatepicker]="datepicker">
            <nb-datepicker     #datepicker></nb-datepicker>
        </div>
         <div style="margin-top: 10px;">
            <div>  <label>Час:</label>  </div>
        <input nbInput  #timeInput [(ngModel)]="dateAndTime.time"   mask="Hh:m0" [showMaskTyped]="true" placeholder="__:__" >
        </div>
      </div>
    </nb-card-body>
        <nb-card-footer>
         
           
      <div style="display:flex; width:100%">

        <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="saveDateTime(ref,dateInput, timeInput )" nbButton status="success" >Зберегти</button>

               <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувти</button>
  
    
            </div>
        </nb-card-footer>
      </nb-card>
       
    </div>
      </ng-template>
